module.exports = __webpack_public_path__ + "static/media/base.725afc12.svg";